export const colors = [
  {
    handle: 'weatherguard',
    colors: [
      {
        name: 'Grey',
        color: 'grey',
        images: [
          {
            type: 'swatch',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/grey.jpg'
          }
        ]
      },
      {
        name: 'Beige',
        color: 'beige',
        images: [
          {
            type: 'swatch',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/beige_1f9dcb99-1394-4033-be83-80a41f01510e.jpg'
          }
        ]
      },
      {
        name: 'Black',
        color: 'black',
        images: [
          {
            type: 'swatch',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/black_f5854ec7-e61b-4beb-bffb-6855f22bcf0b.jpg'
          }
        ]
      },
      {
        name: 'Red',
        color: 'red',
        images: [
          {
            type: 'swatch',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/red_9f5dce5e-afc5-4fd1-ae73-e5efdf8dd535.jpg'
          }
        ]
      },
      {
        name: 'Blue',
        color: 'blue',
        images: [
          {
            type: 'swatch',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/blue_f863b6e9-643e-425d-894f-ded8778c9e89.jpg'
          }
        ]
      }
    ]
  },
  {
    handle: 'ultraguard',
    colors: [
      {
        name: 'Blue',
        color: 'blue',
        images: [
          {
            type: 'swatch',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/blue_f863b6e9-643e-425d-894f-ded8778c9e89.jpg'
          }
        ]
      },
      {
        name: 'Grey',
        color: 'grey',
        images: [
          {
            type: 'swatch',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/grey.jpg'
          }
        ]
      },
      {
        name: 'Beige',
        color: 'beige',
        images: [
          {
            type: 'swatch',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/beige_1f9dcb99-1394-4033-be83-80a41f01510e.jpg'
          }
        ]
      },
      {
        name: 'Black',
        color: 'black',
        images: [
          {
            type: 'swatch',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/black_f5854ec7-e61b-4beb-bffb-6855f22bcf0b.jpg'
          }
        ]
      }
    ]
  },
  {
    handle: 'stormguard',
    colors: [
      {
        name: 'Grey',
        color: 'grey',
        images: [
          {
            type: 'swatch',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/grey-sg.jpg'
          }
        ]
      }
    ]
  },
  {
    handle: 'cotton-flannelguard',
    colors: [
      {
        name: 'Tan',
        color: 'tan',
        images: [
          {
            type: 'swatch',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/tan.jpg'
          }
        ]
      }
    ]
  },
  {
    handle: 'flannelguard-supreme',
    colors: [
      {
        name: 'BH Blue',
        color: 'bh-blue',
        images: [
          {
            type: 'swatch',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/bh-blue.jpg'
          }
        ]
      },
      {
        name: 'Black',
        color: 'black',
        images: [
          {
            type: 'swatch',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/black_f5854ec7-e61b-4beb-bffb-6855f22bcf0b.jpg'
          }
        ]
      },
      {
        name: 'Charcoal',
        color: 'charcoal',
        images: [
          {
            type: 'swatch',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/charcoal_dc077aca-f0a5-4290-af66-140c2a890a7d.jpg'
          }
        ]
      },
      {
        name: 'Red',
        color: 'red',
        images: [
          {
            type: 'swatch',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/red_9f5dce5e-afc5-4fd1-ae73-e5efdf8dd535.jpg'
          }
        ]
      },
      {
        name: 'Navy',
        color: 'navy',
        images: [
          {
            type: 'swatch',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/navy.jpg'
          }
        ]
      },
      {
        name: 'Silver',
        color: 'silver',
        images: [
          {
            type: 'swatch',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/silver_d0b207d7-bac9-4615-8e4a-5d1bcd7cfaf5.jpg'
          }
        ]
      }
    ],
    secondaryColors: [
      {
        name: 'None',
        color: 'none',
        images: [
          {
            type: 'swatch',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/none_8f510aa4-fd23-4c9e-90cf-40b8941c4fab.jpg'
          }
        ]
      },
      {
        name: 'Black',
        color: 'black',
        images: [
          {
            type: 'swatch',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/black_f5854ec7-e61b-4beb-bffb-6855f22bcf0b.jpg'
          }
        ]
      },
      {
        name: 'Red',
        color: 'red',
        images: [
          {
            type: 'swatch',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/red_9f5dce5e-afc5-4fd1-ae73-e5efdf8dd535.jpg'
          }
        ]
      },
      {
        name: 'Silver',
        color: 'silver',
        images: [
          {
            type: 'swatch',
            imageUrl: 'https://cdn.shopify.com/s/files/1/0027/5539/5641/files/silver_d0b207d7-bac9-4615-8e4a-5d1bcd7cfaf5.jpg'
          }
        ]
      }
    ]
  }
];

export const embroideryColors = [
  {
      "name": "Black",
      "color": "black",
      "hex": "#000"
  },
  {
      "name": "Blue",
      "color": "blue",
      "hex": "#2513FE"
  },
  {
      "name": "Maroon",
      "color": "maroon",
      "hex": "#7F0100"
  },
  {
      "name": "Green",
      "color": "green",
      "hex": "#258000"
  },
  {
      "name": "Grey",
      "color": "grey",
      "hex": "#C0C0C0"
  },
  {
      "name": "Orange",
      "color": "orange",
      "hex": "#F7A500"
  },
  {
      "name": "Purple",
      "color": "purple",
      "hex": "#7F027F"
  },
  {
      "name": "Red",
      "color": "red",
      "hex": "#F30103"
  },
  {
      "name": "White",
      "color": "white",
      "hex": "#ffffff"
  },
  {
      "name": "Yellow",
      "color": "yellow",
      "hex": "#FDFE00"
  }
]
